<template>
  <div>
    <ContactListSubscriptionList :contact-list-id="contactList.id" />
  </div>
</template>

<script>
import ContactListSubscriptionList from './components/ContactListSubscriptionList.vue';

export default {
  components: {
    ContactListSubscriptionList,
  },
  props: {
    contactList: {
      type: Object,
      required: true,
    },
  },
};
</script>
